// src/components/home/FloatingProductHunt.jsx
import React, { useState, useEffect } from "react";
import { FaProductHunt, FaHeart, FaTimes, FaChevronUp } from "react-icons/fa";
import "./FloatingProductHunt.css";

const FloatingProductHunt = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDismissed = localStorage.getItem("bodhai_ph_widget_dismissed");
    if (isDismissed === "true") return;

    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("bodhai_ph_widget_dismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <div className="bvh-floating-ph-card">
      <div className="bvh-floating-ph-header">
        <div className="bvh-floating-ph-badge">
          <div className="bvh-ph-icon-box">
            <FaProductHunt />
          </div>
          <span className="bvh-floating-ph-title">We're on Product Hunt</span>
        </div>

        <button
          className="bvh-floating-ph-close"
          onClick={handleDismiss}
          title="Close widget"
        >
          <FaTimes />
        </button>
      </div>

      <p className="bvh-floating-ph-desc">
        Support BodhAI <FaHeart className="heart-icon" /> <br />
        Every upvote helps us build the future of AI learning.
      </p>

      <a
        href="https://www.producthunt.com/products/bodhai?utm_source=bodhai.pages.dev&utm_medium=referral&utm_campaign=bodhai_product_launch_july_2026&utm_content=visit_producthunt_from_bodhai_homepage&utm_term=ai_learning_tool_launch"
        target="_blank"
        rel="noopener noreferrer"
        className="bvh-floating-ph-btn"
      >
        <FaChevronUp style={{ fontSize: "0.85rem" }} /> Upvote Now
      </a>
    </div>
  );
};

export default React.memo(FloatingProductHunt);
